// src/pages/PdfViewer.jsx
import React, { useEffect, useMemo, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import axios from 'axios';

function normalizeKey(raw) {
  let k = raw || '';
  try {
    if (/%[0-9A-Fa-f]{2}/.test(k)) k = decodeURIComponent(k);
  } catch {}
  k = k.replace(/\+/g, '%20').replace(/\/{2,}/g, '/');
  return k;
}

export default function PdfViewer() {
  const { bucketName, '*': keyFromSplat } = useParams();
  const [qs] = useSearchParams();

  const bucket = (bucketName || qs.get('bucket') || '').trim();
  const rawKey = (keyFromSplat && keyFromSplat.length ? keyFromSplat : qs.get('key')) || '';
  const key = useMemo(() => normalizeKey(rawKey), [rawKey]);

  const [url, setUrl] = useState('');
  const [error, setError] = useState('');
  const token = useMemo(() => localStorage.getItem('token') || '', []);

  useEffect(() => {
    let mounted = true;
    async function run() {
      setError('');
      setUrl('');

      if (!bucket || !key) {
        setError('Parâmetros ausentes: bucket e key são obrigatórios.');
        return;
      }

      try {
        // **MESMO FLUXO DO MODAL**: rota autenticada + inline=1
        const base = `${import.meta.env.VITE_BACKEND_URL}/api/share/${encodeURIComponent(bucket)}/${encodeURIComponent(key)}`;
        const { data } = await axios.get(`${base}?expires=900&inline=1`, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });

        if (!data?.url) throw new Error('Resposta sem URL.');
        if (mounted) setUrl(data.url); // use a URL exatamente como veio
      } catch (e) {
        const st = e?.response?.status;
        if (st === 404) setError('Arquivo não encontrado. Verifique caminho/acentos.');
        else if (st === 403) setError('Acesso negado. Sessão expirada ou sem permissão.');
        else setError('Falha ao gerar link de visualização.');
      }
    }
    run();
    return () => { mounted = false; };
  }, [bucket, key, token]);

  const fileName = useMemo(() => {
    try { return decodeURIComponent(key).split('/').pop() || 'arquivo.pdf'; }
    catch { return key.split('/').pop() || 'arquivo.pdf'; }
  }, [key]);

  if (!bucket || !key) {
    return (
      <div style={{ padding: 24, fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, sans-serif' }}>
        <h3>Visualização de PDF</h3>
        <p style={{ color: '#b00020' }}>Parâmetros ausentes: informe bucket e key.</p>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: 24, fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, sans-serif' }}>
        <h3>Visualização de PDF</h3>
        <p style={{ color: '#b00020' }}>{error}</p>
        <div style={{ marginTop: 12, fontSize: 13, color: '#666' }}>
          <div><strong>Bucket:</strong> {bucket}</div>
          <div><strong>Key:</strong> {key}</div>
        </div>
      </div>
    );
  }

  return (
    <div style={{ width: '100vw', height: '100vh', overflow: 'hidden', margin: 0, padding: 0 }}>
      {/* Topbar */}
      <div style={{
        height: 44, display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '0 12px', borderBottom: '1px solid #eee',
        fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, sans-serif'
      }}>
        <div style={{ fontSize: 14, color: '#444', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {fileName}
        </div>
        <div style={{ display: 'flex', gap: 12 }}>
          {url && <a href={url} target="_blank" rel="noreferrer" style={{ fontSize: 14 }}>Abrir em nova guia</a>}
          {url && <a href={url} download style={{ fontSize: 14 }}>Baixar</a>}
        </div>
      </div>

      {!url ? (
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          height: 'calc(100vh - 44px)', fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, sans-serif'
        }}>
          Gerando link temporário…
        </div>
      ) : (
        <iframe
          title="PDF"
          src={`${url}#toolbar=1&navpanes=0`}
          style={{ border: 'none', width: '100vw', height: 'calc(100vh - 44px)' }}
        />
      )}
    </div>
  );
}
